import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

import { CreateMetricValueCommentGQL, UpdateCriticalOrdersCommentGQL } from '../../../../../generated/graphql';
import { StandupDashboardServiceService } from '../../standup-dashboard-service.service';

@Component({
  selector: 'app-critical-orders-comment-dialog',
  templateUrl: './critical-orders-comment-dialog.component.html',
  styleUrls: ['./critical-orders-comment-dialog.component.scss']
})
export class CriticalOrdersCommentDialogComponent implements OnInit {
  commentText = new FormControl('');
  selectedComment;
  isLoading = false;
  comments;
  metricId;
  initialValue;
  isCreating = false;

  @ViewChild('area') area!: ElementRef<HTMLTextAreaElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {comments: {id: string, comment: string}[], metricId: string},
    private updateCriticalOrdersCommentGQL: UpdateCriticalOrdersCommentGQL,
    private createMetricValueCommentGQL: CreateMetricValueCommentGQL,
    private standupDashboardService: StandupDashboardServiceService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<CriticalOrdersCommentDialogComponent>
  ) {
    this.metricId = this.data.metricId;
    if (this.data.comments.length) {
      this.comments = this.data.comments.filter(c => c.id);
      this.commentText.setValue(this.data?.comments[0]?.comment);
      this.selectedComment = this.data?.comments[0];
      this.initialValue = this.data?.comments[0]?.comment;
    } else {
      // this.comments = [{id: '', comment: ''}];
      // this.selectedComment = {id: '', comment: ''};
      // this.isCreating = true;
    }
    setTimeout(() => this.area.nativeElement.focus(), 300);
  }

  ngOnInit(): void {
    // this.commentText.valueChanges.subscribe(v => {
    //   const target = this.comments.find(val => val.id === '');
    //   if (target) {
    //     target.comment = v;
    //   }
    // });
  }

  // selectComment(comment) {
  //   if (comment?.id !== this.selectedComment.id && !this.isLoading) {
  //     this.comments = this.comments.filter(val => val?.id && val?.comment);
  //     this.isCreating = false;
  //     this.selectedComment = comment;
  //     this.commentText.setValue(comment.comment);
  //   }
  // }
  //
  // addComment() {
  //   setTimeout(() => this.area.nativeElement.focus(), 100);
  //   this.comments.push({id: '', comment: ''});
  //   this.selectedComment = {id: '', comment: ''};
  //   this.commentText.setValue('');
  //   this.isCreating = true;
  // }
  //
  // createComment() {
  //   this.commentText.disable();
  //   this.isLoading = true;
  //   this.createMetricValueCommentGQL.mutate({metricValue: this.metricId, comment: this.commentText.value}).subscribe(v => {
  //     const emptyContainer = this.comments.find(val => val.id === '');
  //     if (emptyContainer) {
  //       emptyContainer.id = v.data.createMetricValueComment.metricValueComment.id;
  //       emptyContainer.comment = this.commentText.value;
  //       this.selectedComment = emptyContainer;
  //     }
  //     this.standupDashboardService.changedCommentsSubject.next({ comments: this.comments, id: this.metricId });
  //     this.snackBar.open(this.translateService.instant('CREATED_SUCCESSFULLY'), null, { duration: 3000 });
  //     this.commentText.enable();
  //     this.isCreating = false;
  //     this.isLoading = false;
  //   }, error => {
  //     this.commentText.enable();
  //     this.isLoading = false;
  //     this.isCreating = false;
  //   });
  // }

  updateComment() {
    this.commentText.disable();
    this.isLoading = true;
    this.updateCriticalOrdersCommentGQL.mutate({id: this.selectedComment?.id, comment: this.commentText.value}).subscribe(v => {
      const data = v.data.updateMetricValueComment.metricValueComment;
      if (this.selectedComment?.id === data.id) {
        this.selectedComment = { comment: data.comment, id: data.id };
      }
      this.comments.find(val => val.id === data.id).comment = data.comment;
      this.standupDashboardService.changedCommentsSubject.next({ comments: this.comments, id: this.metricId });
      this.snackBar.open(this.translateService.instant('UPDATED_SUCCESSFULLY'), null, { duration: 2000 });
      this.commentText.enable();
      this.isLoading = false;
      this.dialogRef.close();
    }, error => {
      this.commentText.enable();
      this.isLoading = false;
    });
  }

  // private refresh() {
  //   this.comments = [];
  //   this.metricId = undefined;
  //   this.selectedComment = undefined;
  //   this.isCreating = false;
  // }
}
